import React, { useState } from 'react';
import EditableBranchTemplate from '../components/EditableBranchTemplate';
import { slugify, saveTopic } from '../services/topicRegistry';

async function writeTopicToDisk(topic) {
  try {
    await fetch('https://hello-web3-five.vercel.app/topics', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(topic),
    });
  } catch (_) {
    // If the writer service isn't running, skip silently
  }
}

const NewTopic = () => {
  const [title, setTitle] = useState('New Topic');

  const initialSections = [
    {
      title: 'Section 1',
      content: [
        { type: 'heading', text: 'Getting Started' },
        { type: 'paragraph', text: 'Describe your topic here...' },
        { type: 'list', items: ['First point', 'Second point'] },
      ],
    },
  ];

  return (
    <div>
      <EditableBranchTemplate
        title={title}
        sections={initialSections}
        onSave={async (sections) => {
          const slug = slugify(title) || `topic-${Date.now()}`;
          const topic = { slug, title, sections };
          saveTopic(topic);
          await writeTopicToDisk(topic);
        }}
        startEditing={true}
        onTitleChange={setTitle}
      />
    </div>
  );
};

export default NewTopic;


